import React from "react";
// Components
import VerifySession from "../../../config/verifySession";
import AdminValidation from "../../../config/adminValidation";
import CreateProtocolComponent from "../../../components/protocolsManagement/sections/createProtocol";

const CreateProtocolView = () => (
  <>
    {VerifySession()}
    {AdminValidation()}
    <CreateProtocolComponent />
  </>
);

export default CreateProtocolView;
